import script from "./goRinSyo0061.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0061.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0061.vue?vue&type=style&index=0&id=7d60bc3e&lang=scss"

const __exports__ = script;

export default __exports__